/**
  * 主题色带阴影折线图 
  * @param unit 单位
  * @param xData []x轴数据
  * @param yData []y轴数据合集
*/
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result += item.marker + " " + dealBigNum(item.value) + paramObj.unit + "</br>";
        });
        return result;
      },
    },
    grid: {
      top: "20px",
      left: "50px",
      right: "1%",
      bottom: "10px",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: paramObj.xData,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: "#CBCBCB",
      },
    },
    yAxis: {
      type: "value",
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: "#E5E6EB",
          width: 1,
          type: "dashed",
        },
      },
      axisLabel: {
        color: "#CBCBCB",
        fontSize: 12,
      },
    },
    dataZoom: [
      {
        type: "inside",
      },
    ],
    series: [
      {
        data: paramObj.yData,
        type: "line",
        // smooth: true,
        areaStyle: {
          color: {
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "rgba(40,204,203,0.15)", // 0% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(40,204,203,0)", // 0% 处的颜色
              },
            ],
          },
        },
        lineStyle: {
          color: "#28CCCB",
          width: 3,
          shadowColor: "rgba(40,204,203,0.17)", //设置折线阴影
          shadowBlur: 5,
          shadowOffsetY: 9,
        },
        itemStyle: {
          color: "#28CCCB",
          borderColor: "#28CCCB",
          borderWidth: 5,
        },
        smooth: 0.4,
        emphasis: {
          scale: 1.5,
        },
      },
    ],
  };

  return option
  
}